<div class="template-header">
  <div class="container">
    <img src="assets/img/jt-logo-small.svg" (click)="scrollToTop()" />
    <div class="container__logout-area">
      @if (userNameShorthand()) {
        <p-avatar
          class="container__logout-area__avatar"
          [label]="userNameShorthand()"
          shape="circle" />
      }
      <div class="container__logout-area__user-name">{{ userName() }}</div>
      <img
        class="container__logout-area__logout"
        src="assets/icons/logout.svg"
        (click)="logout()" />
    </div>
  </div>
</div>

<div class="container main-container">
  <router-outlet />
</div>

<div class="template-footer">
  <div class="container">
    <div class="phone-area">
      <div class="phone-area__label input-label">Klientská linka:</div>
      <div class="phone-area__value">800 707 606</div>
    </div>

    <div class="links">
      @for (link of links(); track link) {
        <a class="links__item" target="_blank" [href]="link.url">{{
          link.label
        }}</a>
      }
    </div>
  </div>
</div>
